<template>
  <i
      :class="icon"
      :style="{
      backgroundImage: `linear-gradient(${lineGradientColor}, ${color})`,
    }"
  ></i>
</template>

<script>
import "@/assets/fonts/rock/iconfont.css";

export default {
  name: "RockIcon",
  install(Vue) {
    Vue.component("RockIcon", this);
  },
  props: {
    icon: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "#0a68d1",
    },
  },
  computed: {
    lineGradientColor() {
      const correspondingColor = {
        "#d41f11": "#ff7d6f",
        "#f95800": "#ff7c3c",
        "#f28900": "#ffc43a",
        "#009a48": "#16dd61",
        "#00b897": "#33e2c3",
        "#0a68d1": "#449dff",
        "#8c4ccd": "#c182f7",
      }
      return correspondingColor[this.color.toLowerCase()] || "#606266";
    },
  },
};
</script>
